import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, ButtonBase } from "@mui/material";
import { IconChevronRight } from "@tabler/icons-react";
import { ds, menuIconSx, menuRowSx } from "../theme/keeperTheme";

/**
 * Крупная строка меню: иконка в плашке | подпись (+ подпись-пояснение) | счётчик или шеврон.
 * tone — цвет плашки иконки (primary | info | danger | neutral).
 * trailing — блок справа (например, счётчик); без него рисуем шеврон.
 * disabled — кнопка не нажимается (например, интеграция ещё в разработке);
 * hint — вторая строка под подписью.
 */
export default function MobileMenuButton({
  to,
  icon,
  label,
  hint,
  onClick,
  trailing,
  tone = "primary",
  muted = false,
  disabled = false,
}) {
  const navigate = useNavigate();

  const handle = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
      return;
    }
    if (to) navigate(to);
  };

  const hasTrailing = trailing != null && trailing !== false;
  const dimmed = muted || disabled;

  return (
    <ButtonBase
      onClick={handle}
      focusRipple
      disabled={disabled}
      aria-disabled={disabled || undefined}
      sx={{
        ...menuRowSx,
        maxWidth: 400,
        justifyContent: "flex-start",
        textAlign: "left",
        ...(dimmed ? { bgcolor: ds.surface2, boxShadow: "none" } : null),
        ...(disabled ? { opacity: 0.55, cursor: "default" } : null),
      }}
    >
      <Box sx={menuIconSx(dimmed ? "neutral" : tone)}>{icon}</Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          component="span"
          sx={{
            display: "block",
            fontWeight: 600,
            fontSize: "1rem",
            color: dimmed ? ds.text2 : ds.text,
          }}
        >
          {label}
        </Typography>
        {hint ? (
          <Typography
            component="span"
            sx={{
              display: "block",
              mt: 0.2,
              fontWeight: 500,
              fontSize: "0.75rem",
              lineHeight: 1.35,
              color: ds.text3,
            }}
          >
            {hint}
          </Typography>
        ) : null}
      </Box>
      {hasTrailing ? (
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>{trailing}</Box>
      ) : disabled ? null : (
        <IconChevronRight size={20} stroke={2} color={ds.text3} aria-hidden />
      )}
    </ButtonBase>
  );
}
